import PropTypes from "prop-types";
import React from "react";
import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label } from "reactstrap";

//redux
import { useDispatch } from "react-redux";
import { withRouter, Link, useLocation, useHistory } from "react-router-dom";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { loginUser, socialLogin } from "../../store/actions";

// import images
import Logo from "../../assets/images/logo-large.png";
import "../../assets/scss/custom/style.css";

import Snackbars from "../../Utils/Snackbars";
import useRequestsWOAccessToken from '../../Utils/useRequestsWOAccessToken';


const Login = props => {
  //meta title
  document.title = "Login";
  const dispatch = useDispatch();
	const location = useLocation();
  const history = useHistory();
  const { getRequestWOAccessToken, postRequestWOAccessToken } = useRequestsWOAccessToken();


  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};


  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      userid: '',
      password: '',
    },
    validationSchema: Yup.object({
      userid: Yup.string()
        .max(255)
        .required('User name is required'),
      password: Yup.string().required('Password is required'),
    }),
    onSubmit: async (values) => {
      try {
        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const jsonpar = JSON.stringify({
          userid: values.userid,
          password: values.password,
        });
        const res = await postRequestWOAccessToken('login', jsonpar);
        if (res && res.code === 200) {
          let originalText = res.data;

          // if(originalText.is_email_verified === 0) {
          //   history.push('/mobile-verification', { id: originalText.a_id, email: originalText.email, code: 401, status: 'error', message: res.message });
          // }
          // else if(originalText.is_auth_enabled === 1) {
          //   history.push('/google-auth');
          // }
          // else {
            values.username = originalText.first_name + ' ' + originalText.last_name;
            values.accesstoken = originalText.accesstoken;
            values.refreshtoken = originalText.refreshtoken;
            localStorage.setItem('admin_type', originalText.type);

            if(originalText.type == 'admin'){
              document.documentElement.style.setProperty('--primary-color', '#036b41');
              document.documentElement.style.setProperty('--primary-hover', '#036028ff');
            }else{
              document.documentElement.style.setProperty('--primary-color', '#266199');
              document.documentElement.style.setProperty('--primary-hover', '#17446a');
            }
            
            if(originalText.first_name){
              localStorage.setItem("fullname", originalText.first_name + ' ' + originalText.last_name)
            }else{
              localStorage.setItem("fullname", originalText.organization_name )
            }
            localStorage.setItem('SELECTED_SUPERVISOR_ID', 'all');
            dispatch(loginUser(values, props.history, { code: 200, status: 'success', message: 'Login successful. Welcome back!' }));
          // }
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();

        submit1.disabled = false;
        submit1.textContent = 'Log In';
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  React.useEffect(() => {
    if (typeof location.state !== 'undefined' && typeof location.state.message !== 'undefined') {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: location.state.status,
        message: location.state.message,
      }));
      resetAlertData();
		}
  }, []);

  React.useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.keyCode === 13) {
        document.getElementById('submit1').click();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <React.Fragment>
			{AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="account-pages bg-green">
        <Container className="my-5">
          <Row className="justify-content-center">

            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <CardBody>
                  <Link to="/dashboard" className="logo center-logo">
                    <span className="text-center">
                      <img src={Logo} alt="" />
                    </span>
                  </Link>
                  <h4 className="text-center mt-3 mb-3">Admin Login !</h4>
                  <div className="p-2">
                    <Form className="form-horizontal">
                      <div className="mb-3">
                        <Label className="form-label">{'User name'} :</Label>
                        <Input 
                          name="userid" 
                          type="text" 
                          placeholder={'Enter User name'}
                          onChange={validation1.handleChange}
                          onBlur={validation1.handleBlur}
                          value={validation1.values.userid || ""}
                          invalid={
                            validation1.touched.userid && validation1.errors.userid ? true : false
                          }
                        />
                        {validation1.touched.userid && validation1.errors.userid ? (
                          <FormFeedback type="invalid">{validation1.errors.userid}</FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">{'Password'} :</Label>
                        <Input
                          name="password"
                          type="password" 
                          placeholder={'Enter password'}
                          onChange={validation1.handleChange}
                          onBlur={validation1.handleBlur}
                          value={validation1.values.password || ""}
                          invalid={
                            validation1.touched.password && validation1.errors.password ? true : false
                          }
                        />
                        {validation1.touched.password && validation1.errors.password ? (
                          <FormFeedback type="invalid">{validation1.errors.password}</FormFeedback>
                        ) : null}
                      </div>

                      {/* <div className="form-check">
                        <input type="checkbox" className="form-check-input" id="customControlInline" />
                        <label className="form-check-label" htmlFor="customControlInline" >Remember me </label>
                      </div> */}

                      <div className="mt-3 d-grid">
                        <button 
                          id="submit1"
                          onClick={(e) => {
                            e.preventDefault();
                            validation1.handleSubmit();
                            return false;
                          }}
                          className="btn btn-block" style={{ backgroundColor: '#266199', color: '#fff', border: 'none', width: '100%', padding: '0.5rem 1rem', borderRadius: '0.25rem' }}> {'Log In'} </button>
                      </div>

                      <div className="mt-4 text-center">
                        <Link to="/forgot-password" className="text-muted">
                          <i className="mdi mdi-lock me-1" />
                          Forgot your password?
                        </Link>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>

              <div className="mt-5 text-center">
                <p style={{ color: '#266199' }}> © {new Date().getFullYear()} Utilize Safety.</p>
              </div>

            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};
